export default __webpack_public_path__ + "static/media/abstract.b2f46dec.jpg";